import {
  editComplaint,
  getAllNatureComplaint,
  getComplaintDetails,
  getComplaints,
  getSupportType,
  saveComplaint,
  downloadComplaintReceipt,
  archivedComplaint,
  complaintExport,
  getGuichetUnique,
  getMembersByHouseholdId
} from "@core/actions/complaintAction.ts";
import { FetchStatusType } from "@core/modeles/model.ts";
import { RootState } from "@core/store/store.ts";
import {
  AgressorsInfos,
  ComplaintById,
  ComplaintListDTO,
  ComplaintStatus,
  DropDownList,
  GuichetUniqueDto,
  MembersGuichetUniqueDto,
  NatureComplaintDTO,
  StepsReason,
  SubNatureComplaint,
  SupportTypeModel,
} from "@modules/plaintes/plaintes.model.ts";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaginateResponse } from "@utils/appUtils.ts";
import { Nullable } from "primereact/ts-helpers.js";
interface ComplaintState {
  loadingDownloadPDF: FetchStatusType;
  complaintList: ComplaintListDTO[];

  loading: FetchStatusType;
  stepReasonValue: StepsReason | null;
  natureLists: NatureComplaintDTO[];
  guichetUnique: GuichetUniqueDto | null;
  membersGuichetUnique: MembersGuichetUniqueDto[] | null;
  loadingMembersGuichetUnique: FetchStatusType;
  loadingNature: FetchStatusType;
  loadingSaveComplaint: FetchStatusType;
  loadingEditComplaint: FetchStatusType;
  loadingArchive: FetchStatusType;
  loadingGuichetUnique: FetchStatusType;
  agressorsInfos: AgressorsInfos[];
  complaintResponse: PaginateResponse<ComplaintListDTO> | null;
  selectedReasons: number[];
  natureComplaintSelectedList: NatureComplaintDTO[];
  subNatureComplaintSelectedList: SubNatureComplaint[];
  loadingDetailsComplaint: FetchStatusType;
  complaintDetails: ComplaintById | null;
  complaintId: number | null;
  textAreaStepFive: string;
  selectedStatusStepFive: DropDownList;
  supportLists: SupportTypeModel[];
  loadingSupport: FetchStatusType;
  datestepSeven: Nullable<Date>;
  textAreaStepSeven: string;
  instruction: SupportTypeModel[];
  sendTo: any;
  sector: string;
  receivedComplaint: boolean
  recordValid: boolean
  loadingExportComplaint: FetchStatusType
}

export const statusDefaultValue = { name: "Résolu positif", code: ComplaintStatus.RESOLVED_POSITIVE }

const initialState: ComplaintState = {
  loadingDownloadPDF: FetchStatusType.IDLE,
  complaintResponse: null,
  complaintList: [],
  guichetUnique: null,
  complaintId: null,
  loading: FetchStatusType.IDLE,
  stepReasonValue: null,
  membersGuichetUnique: null,
  natureLists: [],
  loadingNature: FetchStatusType.IDLE,
  loadingMembersGuichetUnique: FetchStatusType.IDLE,
  loadingSaveComplaint: FetchStatusType.IDLE,
  loadingDetailsComplaint: FetchStatusType.IDLE,
  loadingSupport: FetchStatusType.IDLE,
  loadingEditComplaint: FetchStatusType.IDLE,
  loadingArchive: FetchStatusType.IDLE,
  loadingGuichetUnique: FetchStatusType.IDLE,
  selectedReasons: [],
  natureComplaintSelectedList: [],
  subNatureComplaintSelectedList: [],
  textAreaStepFive: "",
  datestepSeven: null,
  textAreaStepSeven: "",
  instruction: [],
  sendTo: undefined,
  sector: "",
  selectedStatusStepFive: statusDefaultValue,
  recordValid: false,
  agressorsInfos: [
    {
      id: 0,
      lastName: "",
      firstName: "",
      sex: "",
      age: undefined,
      nationality: "",
      relation: undefined,
      adresse: "",
    },
  ],
  complaintDetails: null,
  supportLists: [],
  receivedComplaint: false,
  loadingExportComplaint: FetchStatusType.IDLE
};

const ComplaintSlice = createSlice({
  name: "complaint",
  initialState,
  reducers: {
    setReceivedComplaint(state, action: PayloadAction<boolean>) {
      return { ...state, receivedComplaint: action.payload };
    },
    setComplaintList(state, action: PayloadAction<[]>) {
      return { ...state, regionList: action.payload };
    },
    setComplaintId(state, action: PayloadAction<number>) {
      return { ...state, complaintId: action.payload };
    },
    setStepReasonValue(state, action: PayloadAction<StepsReason | null>) {
      return { ...state, stepReasonValue: action.payload };
    },
    setAgressorsInfos(state, action: PayloadAction<AgressorsInfos[]>) {
      return { ...state, agressorsInfos: action.payload };
    },
    setSelectedReasons(state, action: PayloadAction<number[]>) {
      return { ...state, selectedReasons: action.payload };
    },
    setNatureComplaintSelectedList(
      state,
      action: PayloadAction<NatureComplaintDTO[]>
    ) {
      return { ...state, natureComplaintSelectedList: action.payload };
    },
    setSubNatureComplaintSelectedList(
      state,
      action: PayloadAction<SubNatureComplaint[]>
    ) {
      return { ...state, subNatureComplaintSelectedList: action.payload };
    },
    setTextAreaValue(state, action: PayloadAction<string>) {
      return { ...state, textAreaStepFive: action.payload };
    },
    setSelectedStatus(state, action: PayloadAction<DropDownList>) {
      return { ...state, selectedStatusStepFive: action.payload };
    },
    setDate(state, action: PayloadAction<Nullable<Date>>) {
      return { ...state, datestepSeven: action.payload };
    },
    setTextArea(state, action: PayloadAction<string>) {
      return { ...state, textAreaStepSeven: action.payload };
    },
    setSelectedSendTo(state, action: PayloadAction<any>) {
      return { ...state, sendTo: action.payload };
    },
    setSelectedInstruction(state, action: PayloadAction<SupportTypeModel[]>) {
      return { ...state, instruction: action.payload };
    },
    setSector(state, action: PayloadAction<string>) {
      return { ...state, sector: action.payload };
    },
    setRecordValid(state, action: PayloadAction<boolean>) {
      return { ...state, recordValid: action.payload };
    },
  },
  extraReducers: (builder) => {
    // lists complaint
    builder
      .addCase(getComplaints.pending, (state) => {
        return { ...state, loading: FetchStatusType.LOADING };
      })
      .addCase(getComplaints.fulfilled, (state, action) => {
        return {
          ...state,
          loading: FetchStatusType.COMPLETED,
          complaintList: action.payload.data,
          complaintResponse: action.payload,
        };
      })
      .addCase(getComplaints.rejected, (state) => {
        return { ...state, loading: FetchStatusType.FAILED };
      });
    // nature complaint
    builder
      .addCase(getAllNatureComplaint.pending, (state) => {
        return { ...state, loadingNature: FetchStatusType.LOADING };
      })
      .addCase(getAllNatureComplaint.fulfilled, (state, action) => {
        return {
          ...state,
          loadingNature: FetchStatusType.COMPLETED,
          natureLists: action.payload,
        };
      })
      .addCase(getAllNatureComplaint.rejected, (state) => {
        return { ...state, loadingNature: FetchStatusType.FAILED };
      });
    builder
      .addCase(saveComplaint.pending, (state) => {
        return { ...state, loadingSaveComplaint: FetchStatusType.LOADING };
      })
      .addCase(saveComplaint.fulfilled, (state, action) => {
        return {
          ...state,
          loadingSaveComplaint: FetchStatusType.COMPLETED,
        };
      })
      .addCase(saveComplaint.rejected, (state) => {
        return { ...state, loadingSaveComplaint: FetchStatusType.FAILED };
      });

    builder
      .addCase(getComplaintDetails.pending, (state) => {
        return { ...state, loadingDetailsComplaint: FetchStatusType.LOADING };
      })
      .addCase(getComplaintDetails.fulfilled, (state, action) => {
        return {
          ...state,
          loadingDetailsComplaint: FetchStatusType.COMPLETED,
          complaintDetails: action.payload,
        };
      })
      .addCase(getComplaintDetails.rejected, (state) => {
        return { ...state, loadingDetailsComplaint: FetchStatusType.FAILED };
      });

    builder
      .addCase(getSupportType.pending, (state) => {
        return { ...state, loadingSupport: FetchStatusType.LOADING };
      })
      .addCase(getSupportType.fulfilled, (state, action) => {
        return {
          ...state,
          loadingSupport: FetchStatusType.COMPLETED,
          supportLists: action.payload,
        };
      })
      .addCase(getSupportType.rejected, (state) => {
        return { ...state, loadingSupport: FetchStatusType.FAILED };
      });
    builder
      .addCase(editComplaint.pending, (state) => {
        return { ...state, loadingEditComplaint: FetchStatusType.LOADING };
      })
      .addCase(editComplaint.fulfilled, (state) => {
        return {
          ...state,
          loadingEditComplaint: FetchStatusType.COMPLETED,
        };
      })
      .addCase(editComplaint.rejected, (state) => {
        return { ...state, loadingEditComplaint: FetchStatusType.FAILED };
      });
    builder
      .addCase(downloadComplaintReceipt.pending, (state) => {
        return { ...state, loadingDownloadPDF: FetchStatusType.LOADING };
      })
      .addCase(downloadComplaintReceipt.fulfilled, (state) => {
        return {
          ...state,
          loadingDownloadPDF: FetchStatusType.COMPLETED,
        };
      })
      .addCase(downloadComplaintReceipt.rejected, (state) => {
        return { ...state, loadingDownloadPDF: FetchStatusType.FAILED };
      });
      
    builder
    .addCase(archivedComplaint.pending, (state) => {
      return { ...state, loadingArchive: FetchStatusType.LOADING };
    })
    .addCase(archivedComplaint.fulfilled, (state) => {
      return {
        ...state,
        loadingArchive: FetchStatusType.COMPLETED,
      };
    })
    .addCase(archivedComplaint.rejected, (state) => {
      return { ...state, loadingArchive: FetchStatusType.FAILED };
    });
    builder
      .addCase(complaintExport.pending, state =>{
        return {...state, loadingExportComplaint: FetchStatusType.LOADING}
      })
      .addCase(complaintExport.fulfilled, state =>{
        return {...state, loadingExportComplaint: FetchStatusType.COMPLETED}
      })
      .addCase(complaintExport.rejected, state =>{
        return {...state, loadingExportComplaint: FetchStatusType.FAILED}
      });

    builder
      .addCase(getGuichetUnique.pending, (state) => {
        return { ...state, loadingGuichetUnique: FetchStatusType.LOADING };
      })
      .addCase(getGuichetUnique.fulfilled, (state, action) => {
        return { ...state, loadingGuichetUnique: FetchStatusType.COMPLETED, guichetUnique: action.payload };
      })
      .addCase(getGuichetUnique.rejected, (state) => {
        return { ...state, loadingGuichetUnique: FetchStatusType.FAILED, guichetUnique: null };
      });

    builder
      .addCase(getMembersByHouseholdId.pending, (state) => {
        return { ...state, loadingMembersGuichetUnique: FetchStatusType.LOADING };
      })
      .addCase(getMembersByHouseholdId.fulfilled, (state, action) => {
        return { ...state, loadingMembersGuichetUnique: FetchStatusType.COMPLETED, membersGuichetUnique: action.payload };
      })
      .addCase(getMembersByHouseholdId.rejected, (state) => {
        return { ...state, loadingMembersGuichetUnique: FetchStatusType.FAILED, membersGuichetUnique: null };
      });

  },
});

export const {
  setStepReasonValue,
  setAgressorsInfos,
  setSelectedReasons,
  setNatureComplaintSelectedList,
  setSubNatureComplaintSelectedList,
  setComplaintId,
  setTextAreaValue,
  setSelectedStatus,
  setTextArea,
  setDate,
  setSelectedInstruction,
  setSelectedSendTo,
  setSector,
  setReceivedComplaint,
  setRecordValid
} = ComplaintSlice.actions;

export const stepReasonValue = (state: RootState) =>
  state.complaint.stepReasonValue;

export const complaintId = (state: RootState) => state.complaint.complaintId;

export const natureLists = (state: RootState) => state.complaint.natureLists;

export const loadingNature = (state: RootState) =>
  state.complaint.loadingNature;

export const loadingSaveComplaint = (state: RootState) =>
  state.complaint.loadingSaveComplaint;

export const agressorsInfos = (state: RootState) =>
  state.complaint.agressorsInfos;

export const complaintList = (state: RootState) =>
  state.complaint.complaintList;

export const guichetUnique = (state: RootState) => state.complaint.guichetUnique;

export const complaintResponse = (state: RootState) =>
  state.complaint.complaintResponse;

export const loadingListsComplaint = (state: RootState) =>
  state.complaint.loading;

export const selectedReasons = (state: RootState) =>
  state.complaint.selectedReasons;

export const natureComplaintSelectedList = (state: RootState) =>
  state.complaint.natureComplaintSelectedList;

export const subNatureComplaintSelectedList = (state: RootState) =>
  state.complaint.subNatureComplaintSelectedList;

export const complaintDetails = (state: RootState) =>
  state.complaint.complaintDetails;

export const loadingDetailsComplaint = (state: RootState) =>
  state.complaint.loadingDetailsComplaint;

export const textAreaStepFive = (state: RootState) =>
  state.complaint.textAreaStepFive;

export const selectedStatusStepFive = (state: RootState) =>
  state.complaint.selectedStatusStepFive;

export const supportLists = (state: RootState) => state.complaint.supportLists;

export const loadingSupport = (state: RootState) =>
  state.complaint.loadingSupport;

export const datestepSeven = (state: RootState) =>
  state.complaint.datestepSeven;

export const textAreaStepSeven = (state: RootState) =>
  state.complaint.textAreaStepSeven;

export const instruction = (state: RootState) => state.complaint.instruction;

export const sendTo = (state: RootState) => state.complaint.sendTo;

export const sectorStepOne = (state: RootState) => state.complaint.sector;

export const loadingEditComplaint = (state: RootState) =>
  state.complaint.loadingEditComplaint;

export const loadingDownloadPDF = (state: RootState) => state.complaint.loadingDownloadPDF;

export const receivedComplaint = (state: RootState) => state.complaint.receivedComplaint;

export const loadingArchived = (state: RootState) => state.complaint.loadingArchive

export const recordValid = (state: RootState) => state.complaint.recordValid

export const loadingExportComplaint = (state: RootState) => state.complaint.loadingExportComplaint

export const membersGuichetUnique = (state: RootState) => state.complaint.membersGuichetUnique;
export const loadingMembersGuichetUnique = (state: RootState) => state.complaint.loadingMembersGuichetUnique;

export default ComplaintSlice.reducer;


